import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LandingPageSection } from 'src/app/landing-page.model';

@Component({
  selector: 'app-page-heading',
  templateUrl: './page-heading.component.html',
  styleUrls: ['./page-heading.component.scss']
})
export class PageHeadingComponent implements OnInit {

  @Input() data: LandingPageSection;
  @Input() desktopWidth: string = "1110";

  trustedTitle: SafeHtml = null;

  constructor(
    private sanitiser: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.trustedTitle = this.sanitiser.bypassSecurityTrustHtml(this.data.page_heading.title)
  }

}
